import ProtectedRoute from "@components/ProtectedRoute";
import { useIsInclude } from "../../../RoutersCst";
import DashboardPage from "@pages/Contents/Dashboard";
import DashboardEnablement from "@pages/Contents/Dashboard/DashboardEnablement";

const useDashboardEnablement = () => {
  const { isInclude } = useIsInclude();

  return {
    path: "enablement",
    children: [
      {
        index: false,
        path: "",
        element: (
          <ProtectedRoute
            isAllowed={isInclude(
              "smartconfigurator.quicksight.import.dashboards",
            )}
          >
            <DashboardEnablement />
          </ProtectedRoute>
        ),
      },
    ],
  };
};
export default useDashboardEnablement;
